<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h2 class='font-24 font-w-700 theme-color-one'>วันที่ {{dateStr}}</h2>
      </v-col>
    </v-row>
    <v-divider class="my-3" style="border: solid 1px var(--theme-color-one)"></v-divider>
    <div
      v-for="(color, name) in types"
      :key="name">
      <v-row v-if="promotionsByType(name).length > 0">
        <v-col>
          <h2 class="font-18 font-w-100">
            <v-icon :color="color">mdi-square</v-icon>
            {{name}}
          </h2>
        </v-col>
      </v-row>
      <v-row
        v-for="promotion in promotionsByType(name)"
        :key="promotion.Id">
        <v-col cols="4" md="2">
          <v-img
            v-if="promotion.ThumbnailURL__c"
            aspect-ratio="1"
            :src="promotion.ThumbnailURL__c"/>
          <v-img
            v-else
            contain
            aspect-ratio="1"
            :src="require('@/assets/img/Amazon_Logo.png')"/>
        </v-col>
        <v-col cols="8">
          <h3 class="font-16 font-w-700">{{promotion.PromotionName__c}}</h3>
          <p class="desc mt-2">{{promotion.PromotionDescription__c}}</p>
        </v-col>
        <v-col cols="8" offset="4" offset-md="0" md="2" class="text-md-right">
          <span class="theme-color-two">
            <v-icon>mdi-clock-outline</v-icon>
            {{ dateRangeStr(promotion) }}
          </span>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  props: {
    promotions: { types: Array, require: true },
    form: { types: Object, require: true },
  },
  created() {
  },
  methods: {
    promotionsByType(type) {
      return this.promotions.filter(promotion => promotion.PromotionType__c == type)
    },
    dateRangeStr(promotion) {
      const start = this.dateShort(promotion.StartDate__c)

      if (!('EndDate__c' in promotion)) {
        return `${start}. เป็นต้นไป`
      }

      const end = this.dateShort(promotion.EndDate__c)

      return `${start} - ${end}`
    },
    dateShort(dateStr) {
      const m = moment(dateStr)
      return m.format('D MMM') + ' ' + (m.year()+543)%100
    }
  },
  computed: {
    ...mapGetters({
      types: 'Calendar/getTypes',
    }),
    dateStr() {
      const date = new Date(this.form.year, this.form.month, this.form.day)
      return moment(date).format('D MMMM') + ' ' + (this.form.year + 543)
    }
  }
};
</script>

<style scoped>
.desc {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  white-space: normal;
}
</style>